// SSR-safe localStorage guard that mirrors cadence writes locally. It closes the race where a
// remount or full page reload — between firing a cadence mutation (recordShown/recordSnooze) and the
// server state being refetched — re-evaluates `isDue` against stale state and re-shows the prompt,
// producing duplicate "shown" events. The server remains the source of truth; this only prevents the
// client from re-showing during that window.
const LAST_SHOWN_KEY = 'suggestedDarePrompt.lastShownAt';
const SNOOZE_UNTIL_KEY = 'suggestedDarePrompt.snoozeUntil';
const getStore = () => {
    try {
        return typeof window !== 'undefined' ? window.localStorage : null;
    }
    catch (_a) {
        return null;
    }
};
const readNumber = (key) => {
    const store = getStore();
    if (!store) {
        return null;
    }
    try {
        const raw = store.getItem(key);
        if (!raw) {
            return null;
        }
        const parsed = Number(raw);
        return Number.isFinite(parsed) ? parsed : null;
    }
    catch (_a) {
        return null;
    }
};
const writeNumber = (key, value) => {
    const store = getStore();
    if (!store) {
        return;
    }
    try {
        store.setItem(key, String(value));
    }
    catch (_a) {
        // storage unavailable (private mode / quota exceeded) — degrade gracefully
    }
};
export const markPromptShownLocally = (now) => writeNumber(LAST_SHOWN_KEY, now);
export const getLocalLastShownAt = () => readNumber(LAST_SHOWN_KEY);
export const markPromptSnoozedLocally = (snoozeUntil) => writeNumber(SNOOZE_UNTIL_KEY, snoozeUntil);
export const getLocalSnoozeUntil = () => readNumber(SNOOZE_UNTIL_KEY);
